<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="paddingContent">
      <div class="tableWrap">
        <el-table height='660px' stripe :data="postList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in postTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
          <el-table-column
            label="操作"
            width='140'
            fixed="right">
            <template slot-scope="scope">
              <el-button @click="delComment(scope.row.id)" type="text" >刪除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
export default {
  data () {
    return {
      navBlock:'社區',
      navtitle:'帖子評論列表',
      listMenuForm:{
        postId: '',
        postTitle: '',
        startTime: '',
        endTime: '',
      },
      postList:[],
      postTable: [
        {
          prop: 'id',
          label: '評論id',
          width: '170'
        }, {
          prop: 'context',
          label: '評論內容',
          width: ''
        }, {
          prop: 'createDate',
          label: '發佈時間',
          width: '200'
        }
      ],
      id: this.$route.query.id,
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
    }
  },
  created(){
    console.log('555')
    this.getCommentList();
  },
  activated(){
    if (this.currentPage === 1){
      this.getCommentList();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 获取评论列表信息
    getCommentList(){
      let _this = this;
      let param ={
        stickersId: _this.id,
        pageNo: _this.currentPage,
        pageSize: 10,
      }
      _this.$post('/request/community/commentList', param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            _this.total = res.data.allRow;
            res.data.list.forEach(v => {
              v.createDate = _this.$getTime(v.createDate);
            });
            _this.postList = res.data.list

          } else {
            _this.$propMessage(res.message, 'error');
          };
        });
    },
    // 分页
    handleCurrentChange (val) {
      this.currentPage = val;
      this.getCommentList();
    },
    // 删除评论
    delComment(id){
      let _this = this;
      _this.$confirm('是否刪除該評論?', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
        closeOnClickModal: false
        }).then(()=> {
          // 确认删除的回调
          _this.$post(`/request/community/delStickers/comment/${id}`, {}, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible  = true;
              if(res.code === '00000'){

                _this.$propMessage('刪除成功，請稍候', 'success',
                  function(){
                  _this.dialogVisible = false;
                  _this.currentPage = 1;
                  _this.getCommentList();
                 });

              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                  _this.dialogVisible = false;
                 });
              };
          });
      });
    },

  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
  .content{
    .paddingContent{
      .ListMenu{
        .MenuBtnWrap{
          display: flex;
          justify-content: flex-end;
          .btn:last-child{
            margin-left: 0.2rem;
          }
        }
      }
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
    }
    .topBtn{
      width:50px;
    }
  }
  @media screen and (min-width: 769px) {
    .ListMenu{
        display: flex;
        justify-content: space-between;
        .searchForm{
          flex: 1;
          display: flex;
          justify-content: flex-start;
        }
        .MenuBtnWrap{
          flex: 1;
        }
      }
  }
</style>




// WEBPACK FOOTER //
// src/pages/community/postCommentList.vue